module.exports = __webpack_public_path__ + "static/media/melchior_sw.2aa373d9.jpg";